module.exports = __webpack_public_path__ + "static/media/about-3.ee2768d8.jpg";